import React from 'react';
import styles from './ListSimcards.module.scss';

const LoadingDots = () => (
  <span className={styles.loadingDots}>
    <span>.</span>
    <span>.</span>
    <span>.</span>
  </span>
);

export default LoadingDots;
